import PersonChartedDiagnoses from './PersonChartedDiagnoses';

export default PersonChartedDiagnoses;
